import create from 'zustand';
import { IBillAddress } from '@root/types/bill';

export interface IState {
  data: IBillAddress;
  modifyData: any;
  loaded: boolean;
  loadFailed: boolean;
  setLoadFailed: (v: boolean) => void;
  setData: (v: IBillAddress) => void;
  setModifyData: (v: any) => void;
  resetInitData: () => void;
  setLoaded: (v: boolean) => void;
  resetModifyData: () => void;
}

const useBillAddress = create<IState>((set) => ({
  data: {} as IBillAddress,
  modifyData: {},
  loaded: false,
  loadFailed: false,
  setData: (data: IBillAddress) => {
    return set(() => {
      return {
        data,
      };
    });
  },
  setModifyData: (data: any) => {
    return set((state) => {
      return {
        modifyData: {
          ...state.modifyData,
          ...data,
        },
      };
    });
  },
  setLoaded: (loaded) => {
    return set(() => {
      return {
        loaded,
      };
    });
  },
  setLoadFailed: (loadFailed) => {
    return set(() => {
      return {
        loadFailed,
      };
    });
  },
  resetModifyData: () => {
    return set(() => {
      return {
        modifyData: {
          // fromAddressPage: state.modifyData.fromAddressPage,
        },
      };
    });
  },
  resetInitData: () => {
    return set(() => {
      return {
        data: {} as IBillAddress,
        loaded: false,
        loadFailed: false,
        modifyData: {},
      };
    });
  },
}));

export default useBillAddress;
